import { mapState } from 'vuex';
import { isEqual } from 'lodash';
const SUBJECT_EN = '{{exportTitle}} - created at: {{exportDate}}';
const SUBJECT_DE = '{{exportTitle}} - Erstellt am: {{exportDate}}';
const HTML_EN = 'Hello, a new csv export was generated by the scheduled job {{exportTitle}} on {{exportDate}} Download:  <a href="{{downloadLink}}" target="_blank">{{exportTitle}} - {{exportDate}} </a>';
const HTML_DE = 'Hallo, ein neuer csv-Export von Exportzeitplan {{exportTitle}} vom {{exportDate}}  steht zum download bereit. Download: <a href="{{downloadLink}}" target="_blank">{{exportTitle}} - {{exportDate}}</a>';
export default {
  name: 'CoreCsvExportEmail',
  mixins: [],
  props: {
    value: {
      type: Object,
      default: () => ({
        emails: [''],
        selectedMailConnector: null,
        subject: '',
        html: '',
        attachFile: false
      })
    },
    readonly: {
      type: Boolean,
      default: false
    },
    mailConnectors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      internalModel: {
        ...this.value
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    language() {
      return this.$store.state.app.language;
    },
    defaultSubject() {
      return this.language === 'en' ? SUBJECT_EN : SUBJECT_DE;
    },
    defaultHtml() {
      return this.language === 'en' ? HTML_EN : HTML_DE;
    },
    emailRules() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired'), v => /.+@.+\..+/.test(v) || this.$i18n_t('Common.emailValid')];
    },
    hasMailConnectors() {
      return this.mailConnectors && this.mailConnectors.length;
    }
  },
  watch: {
    internalModel: {
      handler() {
        this.emitInput();
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if (!isEqual(newValue, this.internalModel)) {
          this.internalModel = {
            ...this.value
          };
        }
      },
      deep: true
    }
  },
  created() {
    if (!this.internalModel.subject) {
      this.internalModel.subject = this.defaultSubject;
    }
    if (!this.internalModel.html) {
      this.internalModel.html = this.defaultHtml;
    }
  },
  methods: {
    emitInput() {
      this.$emit('input', {
        ...this.internalModel,
        formIsValid: this.internalModel.selectedMailConnector && this.internalModel.emails && this.internalModel.emails.length && this.internalModel.emails.every(element => element && /.+@.+\..+/.test(element)) && this.internalModel.subject && this.internalModel.html
      });
    },
    addEmail(index) {
      this.internalModel.emails.splice(index + 1, 0, '');
    },
    removeEmail(index) {
      if (this.internalModel.emails.length === 1) {
        this.internalModel.emails = [''];
        return;
      }
      this.internalModel.emails.splice(index, 1);
    }
  }
};